module.exports = "/packs/006-706f70e0a03e500ac208ecefa1e5a4e7.jpg";